import { DialogVariables } from './../../../teams/components/Dialog/dialogVariables';

export const dialogVariables = (siteVars): Partial<DialogVariables> => ({
  rootBackground: siteVars.colorScheme.default.background,
});
